export const overlapGroup = (ids, groups) => {
    const groupValue = groups.map(item => item.value);
    const res = ids.filter(item => groupValue.includes(item));
    return res;
};
